class HeroSliderCarousel extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector("[data-slider]");
    this.flickityInstance = null;
    this.initFlickity = this.initFlickity.bind(this);
    this.destroyFlickity = this.destroyFlickity.bind(this);
    this.updateDraggable = this.updateDraggable.bind(this);

    this.mediaQuery = window.matchMedia("(min-width: 60em)");
    this.updateDraggable();
  }

  connectedCallback() {
    this.initFlickity();
    this.mediaQuery.addListener(this.updateDraggable);

    document.addEventListener("shopify:section:load", this.initFlickity);
    document.addEventListener("shopify:section:unload", this.destroyFlickity);
  }

  disconnectedCallback() {
    this.destroyFlickity();
    this.mediaQuery.removeListener(this.updateDraggable);
    document.removeEventListener("shopify:section:load", this.initFlickity);
    document.removeEventListener(
      "shopify:section:unload",
      this.destroyFlickity
    );
  }

  updateDraggable() {
    const isDesktop = this.mediaQuery.matches;
    this.dataset.draggable = !isDesktop;
    if (this.flickityInstance) {
      this.destroyFlickity();
      this.initFlickity();
    }
  }

  initFlickity(event) {
    if (
      this.flickityInstance &&
      (!event || event.detail.sectionId !== this.id)
    ) {
      return;
    }

    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }

    const autoplay = this.dataset.autoplay === "true";
    const interval = parseInt(this.dataset.interval);
    const wrapAround = this.dataset.wrapAround === "true";
    const pageDots = this.dataset.pageDots === "true";
    const prevNextButtons = this.dataset.prevNextButtons === "true";
    const draggable = this.dataset.draggable === "true";

    if (this.sliderElement.children.length > 1) {
      this.flickityInstance = new Flickity(this.sliderElement, {
        cellAlign: "left",
        contain: true,
        groupCells: 1,
        prevNextButtons: prevNextButtons,
        pageDots: pageDots,
        wrapAround: wrapAround,
        autoPlay: autoplay ? interval : false,
        pauseAutoPlayOnHover: true,
        draggable: draggable,
        adaptiveHeight: false,
        percentPosition: true,
      });
    }
  }

  destroyFlickity(event) {
    if (this.flickityInstance) {
      if (!event || event.detail.sectionId === this.id) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }
    }
  }
}

customElements.define("hero-slider-carousel", HeroSliderCarousel);
